import React, { useEffect } from 'react'
import { getQueryParam } from '../../../utils/helpers/url'
import useOAuthLoginRequest from './_request/loginRequest'
import Loading from '../../../packages/kiti/components/helpers/Loading'

export const GoogleLoginPage = props => {
  const reference = getQueryParam('google_oauth')

  const [handleRequest] = useOAuthLoginRequest(reference)

  useEffect(() => {
    handleRequest()
  }, [])

  return <Loading />
}
